export default __webpack_public_path__ + "static/media/square-navigation.033c0795.svg";